module.exports = __webpack_public_path__ + "media/images/icon_arrow_green-12c84bffcbde2d2be0a19b89e30b70af.svg";